import React from "react";
import { motion } from "framer-motion";
import Backdrop from "./Backdrop";

const slideIn = {
  hidden: { x: "100vh", opacity: 0 },
  visible: {
    x: "0",
    opacity: 1,
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: { x: "-100vh", opacity: 0 },
};
const DeleteModal = ({ deleteFunc, id, heading, text, handleClose }) => {
  return (
    <Backdrop onClick={handleClose}>
      <motion.div
        className="rounded max-w-lg min-w-sm bg-white dark:bg-wc-gradient dark:text-white bg-cover text-wc-blue
        shadow-md font-sans p-8 flex flex-col gap-4"
        onClick={(e) => {
          if (e) e.stopPropagation();
        }}
        variants={slideIn}
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.5 }}
      >
        <h2 className="">{heading}</h2>
        <p className="">{text}</p>
        <motion.button
          // whileHover={{ scale: 1.1 }}
          // whileTap={{ scale: 0.9 }}
          className="rounded p-2 bg-red-400 text-white dark:bg-wc-grey flex items-center justify-center m-2 h-button "
          onClick={() => {
            console.log("delete Func", deleteFunc);
            console.log("ID: ", id);
            deleteFunc({ id: id });
            handleClose();
          }}
        >
          Confirm Delete
        </motion.button>
      </motion.div>
    </Backdrop>
  );
};

export default DeleteModal;
